import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import Articles from "./pages/Blog/Blog";
import ArticlePage from "./pages/Blog/BlogPostPage";
import Quests from "./pages/Quests/Quests";
import QuestPage from "./pages/Quests/QuestPage";
import NotFound from "./components/NotFound/NotFound";
import "./App.css";

function AppContent() {
  const location = useLocation();
  const menuItems = [
    { label: "Tavern", href: "/" },
    { label: "Scrolls of Wisdom", href: "/articles" },
    { label: "Quests", href: "/projects" },
  ];

  const getCurrentPage = () => {
    if (location.pathname.startsWith("/articles")) return "Scrolls of Wisdom";
    if (location.pathname === "/") return "Tavern";
    if (location.pathname.startsWith("/projects")) return "Quests";
    return "";
  };

  return (
    <>
      <Navbar
        logo={process.env.PUBLIC_URL + "/{JO}.svg"}
        currentPage={getCurrentPage()}
        menuItems={menuItems}
      />
      <div className="main-content-wrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/projects" element={<Quests />} />
          <Route path="/projects/:slug" element={<QuestPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
